<!-- <form name="frmAcc" #frmAcc="ngForm"> -->
    <div class="card">
        <div class="card-header">
            <label class="control-label" paflabel="Accidentologie"></label>
        </div>
        <div class="card-body">
            <div class="row  justify-content-start">
                <div class="col-4">
                    <label class="control-label" paflabel="Periode_concernee_par_ces_chiffres"></label>
                </div>
                <div class="col-2">
                    <kendo-datepicker name="AccDatDeb" [minDate]="fromDate" [maxDate]="accDatDebMax" allowInput="true"
                        [(ngModel)]="supplier.AccDatDeb" #AccDatDebModel="ngModel" required [disabled]="readonly">
                    </kendo-datepicker>
                    <validation-errors [form]="frmAcc" controlName="AccDatDeb"></validation-errors>
                </div>
                <div class="col-2">
                    <kendo-datepicker name="AccDatFin" [minDate]="accDatFinMin" [maxDate]="toDate" allowInput="true"
                        [(ngModel)]="supplier.AccDatFin"#AccDatFinModel="ngModel" required [disabled]="readonly">
                    </kendo-datepicker>
                    <validation-errors [form]="frmAcc" controlName="AccDatFin"></validation-errors>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="row  justify-content-start">
                        <div class="col-8">
                            <label class="control-label" paflabel="nbSalaries"></label>
                        </div>
                        <div class="col-4">
                            <input type="number" class="form-control" name="nbSalaries"
                                [(ngModel)]="supplier.NbEmployees" #NbEmployeesModel="ngModel" min="0" required [disabled]="readonly">
                            <validation-errors [form]="frmAcc" controlName="nbSalaries"></validation-errors>
                        </div>
                    </div>
                    <div class="row  justify-content-start">
                        <div class="col-8">
                            <label class="control-label" paflabel="nbHeures"></label>
                        </div>
                        <div class="col-4">
                            <input type="number" class="form-control" name="nbHeures" [(ngModel)]="supplier.NbWorkHours" #NbWorkHoursModel="ngModel"
                                min="0" required [disabled]="readonly">
                            <validation-errors [form]="frmAcc" controlName="nbHeures"></validation-errors>
                        </div>
                    </div>
                    <div class="row  justify-content-start">
                        <div class="col-8">
                            <label class="control-label" paflabel="nbJPerdus"></label>
                        </div>
                        <div class="col-4">
                            <input type="number" class="form-control" name="nbJPerdus"
                                [(ngModel)]="supplier.NbWorkAccLostDays" #NbWorkAccLostDaysModel="ngModel" min="0" required [disabled]="readonly">
                            <validation-errors [form]="frmAcc" controlName="nbJPerdus"></validation-errors>
                        </div>
                    </div>
                    <div class="row  justify-content-start">
                        <div class="col-8">
                            <label class="control-label" paflabel="nbAccAvecArret"></label>
                        </div>
                        <div class="col-4">
                            <input type="number" class="form-control" name="nbAccAvecArret"
                                [(ngModel)]="supplier.NbWorkAccStop" #NbWorkAccStopModel="ngModel" min="0" required [disabled]="readonly">
                            <validation-errors [form]="frmAcc" controlName="nbAccAvecArret"></validation-errors>
                        </div>
                    </div>
                    <div class="row  justify-content-start">
                        <div class="col-8">
                            <label class="control-label" paflabel="nbAccSansArret"></label>
                        </div>
                        <div class="col-4">
                            <input type="number" class="form-control" name="nbAccSansArret"
                                [(ngModel)]="supplier.NbWorkAccNoStop" #NbWorkAccNoStopModel="ngModel" min="0" required [disabled]="readonly">
                            <validation-errors [form]="frmAcc" controlName="nbAccSansArret"></validation-errors>
                        </div>
                    </div>
                </div>
                <div class="col-6 d-flex justify-content-center align-items-center">
                    <label class="control-label mt-1 text-primary" paflabel="MSG_INFO_ACCIDENTOLOGIE"></label>
                </div>
            </div>

            <div *ngIf="relanceAccAllowed" class="d-flex justify-content-center align-items-center my-2">
                <button type="button" class="btn btn-sm btn-success" (click)="relance()">Relance</button>
            </div>

            <div class="row justify-content-start">
                <div class="col-12 mt-1">
                    <table class="table table-responsive table-condensed" style="width:100%;">
                        <thead>
                            <tr style="text-align: center;">
                                <th paflabel="Taux" style="min-width:200px;"></th>
                                <th paflabel="Valeur_calculee" style="min-width:130px;"></th>
                                <th paflabel="Valeur_corrigee" style="min-width:130px;"></th>
                                <th style="width:100%;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td paflabel="Taux_de_gravite"></td>
                                <td class="text-right">
                                    <div class="form-control">{{TGCalc()}}</div>
                                </td>
                                <td>
                                    <kendo-numerictextbox [name]="'TG'" [(ngModel)]="supplier.TG" #TGModel="ngModel" [min]="0"
                                        [step]="0.01" [disabled]="readonly">
                                    </kendo-numerictextbox>
                                </td>
                                <td><label class="control-label mt-1 text-primary" paflabel="TG_Description"></label>
                                </td>
                            </tr>
                            <tr>
                                <td paflabel="Taux_de_frequence_1"></td>
                                <td class="text-right">
                                    <div class="form-control">{{TF1Calc()}}</div>
                                </td>
                                <td>
                                    <kendo-numerictextbox [name]="'TF1'" [(ngModel)]="supplier.TF1" #TF1Model="ngModel" [min]="0"
                                        [step]="0.01" [disabled]="readonly">
                                    </kendo-numerictextbox>
                                </td>
                                <td><label class="control-label mt-1 text-primary" paflabel="TF1_Description"></label>
                                </td>
                            </tr>
                            <tr>
                                <td paflabel="Taux_de_frequence_2"></td>
                                <td class="text-right">
                                    <div class="form-control">{{TF2Calc()}}</div>
                                </td>
                                <td>
                                    <kendo-numerictextbox [name]="'TF2'" [(ngModel)]="supplier.TF2" #TF2Model="ngModel" [min]="0"
                                        [step]="0.01" [disabled]="readonly">
                                    </kendo-numerictextbox>
                                </td>
                                <td><label class="control-label mt-1 text-primary" paflabel="TF2_Description"></label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="card" *ngIf="accHistoryVisible">
                <div class="card-header">
                    <label class="control-label" paflabel="Historique"></label>
                </div>
                <div class="card-body d-flex justify-content-center">

                    <table class="table table-condensed">
                        <thead style="text-align: right;">
                            <th>Du</th>
                            <th>Au</th>
                            <th paflabel="Taux_de_gravite"></th>
                            <th paflabel="Taux_de_frequence_1"></th>
                            <th paflabel="Taux_de_frequence_2"></th>
                        </thead>
                        <tbody>
                            <tr *ngFor="let acc of SupplierAccHistory" style="text-align: right;">
                                <td>{{acc.AccDatDeb | date : 'shortDate'}}</td>
                                <td>{{acc.AccDatFin | date : 'shortDate'}}</td>
                                <td>{{acc.TG}}</td>
                                <td>{{acc.TF1}}</td>
                                <td>{{acc.TF2}}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>
<!-- </form> -->